import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachesparkComponent } from './simple-icons-apachespark.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachesparkComponent ],
    exports:      [ SimpleIconsApachesparkComponent ],
    bootstrap:    []
})
export class SimpleIconsApachesparkModule {}
